// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"7210241f","478":"ebc6606f","848":"9dfd7519","936":"fe1ca289"}[chunkId] + ".chunk.css";
};